/**
 * Application name configuration
 */
export const APP_NAME = import.meta.env.VITE_NAME || 'Orange Pill App';
export const APP_NAME_WITH_WEB = APP_NAME + ' | Web App';

